import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { WrapperHttpService } from '../../../../../../services/wrapper-http-service';
import {
  CompartmentRuleDeleteItemParams,
  CompartmentRuleItem,
  CompartmentRuleItemCreateParams,
  CompartmentRuleItemGetCarriersParams,
  CompartmentRuleItemGetDocksParams,
  CompartmentRuleItemURIParams,
} from '../../../models/compartment-rule-item.model';
import { API_URL } from '../../../../../../../services/config';
import { HubEndpoint } from '../../../../hub/constants';
import { CompartmentEndpoint } from '../../../constants/compartment-endpoint';
import { DockBrief } from '../../../../dock/models';
import { AddressModel, CarrierModel, ListObject } from '../../../../../../../common/models';
import { getQueryStringFromObject, transformAddressDetailsIntoModel } from '../../../../../../../common/utils';
import { UliEndpoint } from '../../../../../monitoring/allocation-view/uli/constants';
import { AddressDetailsModel } from '../../../../../address/models/address.model';

@Injectable({
  providedIn: 'root',
})
export class CompartmentRuleItemService {
  constructor(private http: WrapperHttpService) {}

  getCompartmentRuleItem({
    hubId,
    compartmentId,
    ruleId,
  }: CompartmentRuleItemURIParams): Observable<CompartmentRuleItem> {
    const url = `${API_URL}${HubEndpoint.Base}/${hubId}${CompartmentEndpoint.Base}/${compartmentId}${CompartmentEndpoint.Rules}/${ruleId}`;
    return this.http.withLoading().get<CompartmentRuleItem>(url);
  }

  getDocks(params: CompartmentRuleItemGetDocksParams): Observable<ListObject<DockBrief>> {
    const { hubId, compartmentId, filter, page, size } = params;
    const url = `${API_URL}${HubEndpoint.Base}/${hubId}${CompartmentEndpoint.Base}/${compartmentId}${CompartmentEndpoint.Docks}`;

    return this.http.withLoading().get<ListObject<DockBrief>>(
      `${url}?${getQueryStringFromObject({
        filter,
        page,
        size,
      })}`,
    );
  }

  getCarriers(params: CompartmentRuleItemGetCarriersParams): Observable<CarrierModel[]> {
    const url = `${API_URL}${UliEndpoint.WebUli}${UliEndpoint.Carriers}`;

    return this.http.withLoading().get<CarrierModel[]>(`${url}?${getQueryStringFromObject(params)}`);
  }

  getAddresses(params: CompartmentRuleItemGetCarriersParams): Observable<AddressModel[]> {
    const url = `${API_URL}${CompartmentEndpoint.Addresses}`;

    return this.http
      .withLoading()
      .get<AddressDetailsModel[]>(`${url}?${getQueryStringFromObject(params)}`)
      .pipe(map((response: AddressDetailsModel[]) => transformAddressDetailsIntoModel(response)));
  }

  createCompartmentRuleItem({
    hubId,
    compartmentId,
    body,
  }: CompartmentRuleItemCreateParams): Observable<CompartmentRuleItem> {
    const url = `${API_URL}${HubEndpoint.Base}/${hubId}${CompartmentEndpoint.Base}/${compartmentId}${CompartmentEndpoint.Rules}`;
    return this.http.withLoading().post<CompartmentRuleItem>(url, body);
  }

  deleteCompartmentRuleItems({
    hubId,
    compartmentId,
    ruleIds: body,
  }: CompartmentRuleDeleteItemParams): Observable<CompartmentRuleItem> {
    const url = `${API_URL}${HubEndpoint.Base}/${hubId}${CompartmentEndpoint.Base}/${compartmentId}${CompartmentEndpoint.Rules}`;
    return this.http.withLoading().delete<CompartmentRuleItem>(url, { body });
  }
}
